import { Accordion, AccordionDetails, AccordionSummary, Button, InputAdornment, MenuItem, Select, Stack, Table, TableBody, TableCell, TableContainer, TextField, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import Paper from '@mui/material/Paper';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PlaceIcon from '@mui/icons-material/Place';
import PublicIcon from '@mui/icons-material/Public';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SellIcon from '@mui/icons-material/Sell'
import { useSnackbar } from '../Providers/SnackbarProvider/SnackbarProvider';
import { SkeletonLoadImage } from '../Components/SkeletonLoadImage/SkeletonLoadImage';

export default function ShoppingCart({ removeFromCartNum }) {
  const API = '/.netlify/functions'
  // get the cart items
  let [cartItems, setCartItems] = useState(
    JSON.parse(localStorage.getItem("items")) ? 
    JSON.parse(localStorage.getItem("items")).map(v => ({...v, expanded: false})) : 
    []
  )
  
  const [disabled, setDisabled] = useState(false)

  const [name, setName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
  const [country, setCountry] = useState('Select country*')
  const [address, setAddress] = useState('')
  const [postcode, setPostcode] = useState('')
  const snackbar = useSnackbar();
    

  const [promocode, setPromocode] = useState('')
  // const promocode = '';

  const handleExpand = (idx) => {
    let tempItems = cartItems
    tempItems = tempItems.map((item, index) => {
      if (idx === index) {
        return {...item, expanded: !item.expanded}
      }
      return item
    }) 

    setCartItems(tempItems)
  }

  
  const handleCartRemove = (idx) => {
    let tempItems = cartItems
    tempItems = tempItems.filter((item, index) => idx !== index)
    setCartItems(tempItems)
    removeFromCartNum()
    tempItems = JSON.parse(localStorage.getItem("items")).filter((item, index) => idx !== index)
    localStorage.setItem("items", JSON.stringify(tempItems))
  }


  const checkout = async () => {
    if (!validate()) {
      return
    }
    setDisabled(true)
    snackbar.showSnackbar({
      severity: 'info',
      message: 'We are setting up your checkout session. One moment 🙂',
      autoHideDuration: 4000
    })
    try {
      // call Stripe API endpoint for link
      let res = await fetch(`${API}/checkout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json'},
        body: JSON.stringify({
          name: name.trim(),
          phoneNumber: phoneNumber.trim(),
          email: email.trim(),
          country,
          address,
          postcode,
          promocode,
          cartItems
        })
      })
      let jsonRes = await res.json()
      localStorage.setItem('name', name)
      localStorage.setItem('email', email)

      window.location.replace(jsonRes["message"]["url"])
    } 
    catch (e) {
      snackbar.showSnackbar({
        severity: 'error',
        message: 'An unexpected error occurred 😔. Please contact me.',
        autoHideDuration: 10000
      })
    }
    

  }

  const validate = () => {
    let message = ''

    if (name === '') {
      message = 'Please enter your name'
    }
    else if (phoneNumber === '') {
      message = 'Please enter your phone number'
    }
    else if (email === '') {
      message = 'Please enter your email'
    }
    else if (country === 'Select country*') {
      message = 'Please select a country'
    }
    else if (address === '') {
      message = 'Please enter your address'
    }
    else if (postcode === '') {
      message = 'Please enter your postcode'
    }

    if (message) {
      snackbar.showSnackbar({
        severity: 'error',
        message,
        autoHideDuration: 2000
      })
      return false
    }

    return true
  }

  // list of countries, perhaps make this fetched from the db.
  const countries = [
    'Select country*', 'Afghanistan', 'Aland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bangladesh', 'Barbados', 'Bahamas', 'Bahrain', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'British Indian Ocean Territory', 'British Virgin Islands', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo-Brazzaville', 'Congo-Kinshasa', 'Cook Islands', 'Costa Rica', 'Croatia', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'El Salvador', 'Egypt', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Federated States of Micronesia', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Lands', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and McDonald Islands', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iraq', 'Ireland', 'Isle of Man', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine','Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn Islands', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russia', 'Rwanda', 'Saint Barthélemy', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin', 'Saint Pierre and Miquelon', 'Saint Vincent', 'Samoa', 'San Marino', 'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Korea', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Sweden', 'Swaziland', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Vietnam', 'Venezuela', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'
  ];

  return (
    <Box sx={{ ml: '10px', mr: '10px'}}>
      <Typography variant='h4' align='center' gutterBottom marginTop={1} mb={1}>
          My Shopping Cart
      </Typography>
      <Box sx={{
        display: 'flex', 
        flexDirection: 'row', 
        '@media screen and (max-width: 780px)': {
          flexDirection: 'column'
        }   
      }}>
        <Box sx={{ width: '100%' }} mr='50px' mb='40px'>

          { !cartItems.length && 
            <Typography align='center'>
              No items in your cart yet. Head over to products to get started 🙂
            </Typography>
          }
          <TableContainer component={Paper}>
          <Table sx={{ minWidth: '320px' }} aria-label="simple table">
            {
              cartItems.map((item, idx) => (
                <TableBody key={idx}>
                  <TableCell>
                      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                        {/* Clicking the photo or product name takes you to the product page */}
                        <Box mr={'20px'}>
                          <SkeletonLoadImage 
                            height={'80px'}
                            width={'80px'}
                            src={`https://cdn.artbykynaat.com/${item.image}`} 
                          />
                        </Box>
                        <Box width={'100%'}>
                          <b style={{display: 'block', fontSize: '20px', marginBottom: '-6px'}}>
                            {item.productName}
                          </b>
                          <Box sx={{ color: 'rgb(153, 153, 153)' }}>
                            {item.size}
                          </Box>
                          <Box sx={{
                              marginTop: '5px',
                              marginRight: '10px',
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              backgroundColor: `${item.colour ? item.colour : '' }`,
                              position: 'relative',
                              boxShadow:`${item.colour ? '0 0 0 0.1pt black' : '' }`,
                              ':hover': {
                                cursor: 'pointer'
                              }
                            }}
                          />
                          {
                            item.customise &&
                            <Accordion sx={{ marginTop: '15px', width: '100%'}} expanded={item.expanded} onChange={() => handleExpand(idx)}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel4bh-content"
                                id="panel4bh-header"
                              >
                                  <Typography sx={{ width: '33%', flexShrink: 0 }}>Customisation</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                  <Typography sx={{}}>
                                    {item.customise}
                                  </Typography>
                                </AccordionDetails>
                              </Accordion>
                          }
                        </Box>
                      </Box>
                      
                      
                  </TableCell>
                  <TableCell align="right" sx={{ verticalAlign: 'top' }}>
                    <Box textAlign={'right'}>
                      <b style={{ fontSize: '18px' }}>
                        ${JSON.parse(localStorage.getItem("items"))[idx].price}
                      </b>
                      <Box 
                        onClick={() => {handleCartRemove(idx)}}
                        sx={{
                          textDecoration: 'underline red',
                          cursor: 'pointer',
                          color: 'red',
                          fontSize: '12px'
                        }}
                      >
                        Remove
                      </Box>
                    </Box>
                    
                  </TableCell>
                </TableBody>
              ))
            }
          </Table>
          </TableContainer>
          <Box mt={'30px'} sx={{fontSize: '20px', display: 'flex', justifyContent: 'space-between'}}>
            <b>Total cost</b>
            <Box>
              <b style={{ fontSize: '18px', fontFamily: '"Roboto","Helvetica","Arial",sans-serif' }}>
                ${parseFloat(cartItems.reduce((price, item) => price + Number(item.price), 0)).toFixed(2)} (Excl. Shipping)
              </b>
            </Box>
          </Box>
        </Box>
        {/* Form to fill */}
        <Stack sx={{ 
          width: '100%', 
          marginBottom: '40px',
        }} spacing={3}>
          <Box sx={{ fontSize: '20px', color: 'rgb(117, 117, 117)', textAlign: 'center' }}>
            <b>
              Checkout Details
            </b>
          </Box>
          
          <TextField 
            label="Full Name"
            fullWidth 
            placeholder='Full Name' 
            name='name' 
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon />
                </InputAdornment>
              ),
            }}
            value={name}
            onChange={e => setName(e.target.value)}
          />

          <TextField 
            label="Phone number"
            fullWidth 
            placeholder='Phone number'
            name='phone'
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PhoneIphoneIcon />
                </InputAdornment>
              ),
            }}
            value={phoneNumber}
            onChange={e => setPhoneNumber(e.target.value)}
          />

          <TextField 
            label="Email"
            fullWidth 
            placeholder='Enter an email' 
            name='email' 
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailIcon />
                </InputAdornment>
              ),
            }}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />

          {/* <Box sx={{ position: 'relative' }}>
            <PublicIcon sx={{ position: 'absolute', top: '15px', left: '14px', color: 'rgb(117, 117, 117)' }}/>
            <select
              name="country"
              value={country}
              style={{ 
                width: '100%', 
                height: '56px', 
                fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                fontSize: '1rem',
                letterSpacing: '0.00938em',
                lineHeight : '1.4375em',
                paddingLeft: '40px',
                borderColor: 'rgb(195, 195, 195)',
                borderRadius: '5px',
                color: `${country !== 'Select country*' ? '' : 'rgb(163, 163, 163)'}`
              }}
              
              onChange={e => setCountry(e.target.value)}
            >
              {countries.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
              ))}
            </select>
          </Box> */}
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            required
            value={country}
            onChange={(e) => {setCountry(e.target.value)}}
            sx={{minWidth: '145px', textAlign: 'left'}}
            MenuProps={{ 
              PaperProps: { sx: { maxHeight: '400px' } },  
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              transformOrigin: {
                vertical: "top",
                horizontal: "left"
              },
            }}
            startAdornment={
              <InputAdornment position="start">
                <PublicIcon />
              </InputAdornment>
            }
          >
            {
              countries.map((key) => (
                <MenuItem value={key} >
                  {key}
                </MenuItem>
              ))
            }
          </Select>

          <TextField 
            label='Address'
            fullWidth 
            placeholder='Type in your full address' 
            name='address' 
            required
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <HomeIcon />
                </InputAdornment>
              ),
            }}
            value={address}
            onChange={e => setAddress(e.target.value)}
          />

          <TextField 
            label="Postcode"
            fullWidth 
            placeholder='Postcode / Zipcode' 
            name='postcode'
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <PlaceIcon />
                </InputAdornment>
              ),
            }}
            value={postcode}
            onChange={e => setPostcode(e.target.value)}
          />

          <TextField 
            label="Promotion Code"
            fullWidth
            placeholder='Promotion Code'
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SellIcon />
                </InputAdornment>
              ),
            }}
            value={promocode}
            onChange={e => setPromocode(e.target.value)}
          />
          
          <Typography align='center'>
            Customers are responsible for any customs and import taxes that may apply
          </Typography>

            <Button fullWidth variant='contained'
              sx={{
                bgcolor: 'black',
                color: 'white',
                // border: '1px white solid',
                ':hover': {
                  bgcolor: 'white',
                  color: 'black',
                  border: '1px black solid'
                },
                fontSize: '11pt'

              }}
              endIcon={<ArrowForwardIcon/>}
              onClick={checkout}
              disabled={cartItems.length === 0 || disabled}
            > 
              Checkout
            </Button>
        </Stack>
        
      </Box>
    </Box>
  )
}
